import React, {Suspense, useCallback, useEffect, useMemo, useRef, useState} from 'react';
import CalendrierGridRowCells from "./calendrier-grid-row-cells";
import {useCalendrierProps} from "./calendrier";
import {ISelectedCells} from "./calendrier-interfaces";

interface ICalendrierRowsProps {
    selectedCells: ISelectedCells[];
}

const CalendrierGridRows = ({selectedCells}: ICalendrierRowsProps) => {
    const {unites} = useCalendrierProps()

    const isSelectedDate = useCallback((ligne: number) => {
        return selectedCells.some(cell => cell.ligne == ligne)
    }, [selectedCells]);

    return <>
        {unites?.map((unite, index) => {
            return <CalendrierGridRowCells key={`calendrier-grid-cells-${unite.idUnite}`} ligne={index} unite={unite} isSelected={isSelectedDate(index)}/>
        })}
    </>;
};

export default CalendrierGridRows;